<template>
    <ClientLayout>
        <component v-if="exists" :is="`page-${section}-${page}`"></component>
    </ClientLayout>
</template>

<script>
import router from '@/router';
import '@/components/_common';
import '@/components/_pages';
import { get } from 'vuex-pathify';

const validate = vm => {
    if (!vm.exists) {
        router.replace({ name: 'home' });
        return false;
    }

    if (!localStorage.devmode) {
        // don't enforce access page access rules if devmode is enabled
        const section = parseInt(vm.section);
        const page = parseInt(vm.page);
        if (
            !section ||
            !page ||
            section > (vm.firstIncompleteSection || Number.MAX_VALUE) ||
            (section != 9 && page > 1 && !vm.$store.get('hasVisited', { section: section, page: page - 1 })) ||
            // special ugly handling for section 9 to work around dynamic path from prep adherence pages
            // if it is one of the first 15 pages, normal hadVisited rules apply (have to visit prior page)
            // otherwise, just need to have gotten past page 15
            (section == 9 && page > 1 && page < 16 && !vm.$store.get('hasVisited', { section: section, page: page - 1 })) ||
            (section == 9 && page >= 16 && !vm.$store.get('hasVisited', { section: section, page: 15 }))
        ) {
            router.replace({ name: 'home' });
            return false;
        }
    }

    return true;
};

const exists = to => {
    const component = `page-${to.params.section}-${to.params.page}`;
    return component in router.app.$options.components;
};

const history = (to, from, prev) => {
    const next = { from: from.path, to: to.path, enter: new Date() };
    if (prev) {
        prev.leave = next.enter;
    }
    return next;
};

export default {
    name: 'Page',
    props: {
        section: String,
        page: String
    },
    data: () => ({
        history: [],
        repeat: false
    }),
    mounted() {
        if (validate(this)) {
            this.$store.commit('visitPage', { section: this.section, page: this.page });
        }
        this.repeat = this.$store.get(`section${this.section}/complete`);
    },
    updated() {
        if (validate(this)) {
            this.$store.commit('visitPage', { section: this.section, page: this.page });
        }
    },
    computed: {
        firstIncompleteSection: get('firstIncompleteSection'),
        hasVisited: get('hasVisited'),
        prev() {
            return this.history.length ? this.history[this.history.length - 1] : null;
        },
        exists() {
            return `page-${this.section}-${this.page}` in this.$options.components;
        }
    },
    beforeRouteEnter(to, from, next) {
        if (!exists(to)) {
            return next({ name: 'home', replace: true });
        }
        next(vm => {
            vm.history = [history(to, from)];
        });
    },
    beforeRouteUpdate(to, from, next) {
        if (!exists(to)) {
            return next({ name: 'home', replace: true });
        }
        this.history.push(history(to, from, this.prev));
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.history.push(history(to, from, this.prev));
        next();
    },
    async beforeDestroy() {
        try {
            await this.$api.post('/history', {
                section: {
                    id: this.section,
                    title: this.$store.get(`section${this.section}/title`),
                    complete: this.$store.get(`section${this.section}/complete`),
                    repeat: this.repeat
                },
                history: this.history
            });
        } catch (error) {
            // nothing
        }
    }
};
</script>
